import React, { useState } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const SortableImageItem = ({ id, img, onRemove, isCover }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const [imgError, setImgError] = useState(false);
  const [imgLoading, setImgLoading] = useState(true);
  const [openPreview, setOpenPreview] = useState(false);

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <>
      <div
        ref={setNodeRef}
        style={style}
        className="relative h-16 w-16 sm:h-20 sm:w-20 md:h-24 md:w-24 rounded-xl overflow-hidden border bg-white"
      >
        <div
          {...attributes}
          {...listeners}
          className="absolute top-1 left-1 z-20 cursor-grab bg-black/60 text-white text-sm px-2 py-1 rounded-md touch-none"
        >
          ⠿
        </div>

        {imgError ? (
          <div className="w-full h-full bg-gray-200 flex items-center justify-center">
            <span className="text-xs text-gray-500">Image error</span>
          </div>
        ) : (
          <>
            {imgLoading && (
              <div className="absolute inset-0 bg-gray-100 animate-pulse z-0" />
            )}

            <img
              src={img.preview}
              alt=""
              className={`w-full h-full object-cover cursor-pointer ${
                imgLoading ? "hidden" : ""
              }`}
              onLoad={() => setImgLoading(false)}
              onError={() => setImgError(true)}
              draggable={false}
              onClick={() => setOpenPreview(true)}
            />
          </>
        )}

        {isCover && (
          <span className="absolute bottom-1 left-1 z-20 bg-[#FFEFEB] text-[#FF6943] text-[10px] px-2 py-0.5 rounded-full">
            Cover
          </span>
        )}

        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          className="absolute top-1 right-1 z-20 bg-black/70 text-white w-5 h-5 rounded-full flex items-center justify-center text-xs hover:bg-red-600"
        >
          ×
        </button>
      </div>

      {openPreview && (
        <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4">
          {/* Popup image */}
          <img
            src={img.preview}
            alt=""
            className="max-h-[90vh] max-w-[90vw] rounded-xl shadow-2xl"
          />

          {/* Close button */}
          <button
            onClick={() => setOpenPreview(false)}
            className="absolute top-5 right-5 z-60 bg-black/70 text-white w-8 h-8 rounded-full flex items-center justify-center text-lg hover:bg-red-600"
          >
            ×
          </button>

          {/* Clicking outside still closes */}
          <div
            className="absolute inset-0"
            onClick={() => setOpenPreview(false)}
          />
        </div>
      )}
    </>
  );
};

export default SortableImageItem;
